import { render, staticRenderFns } from "./app-bar-notification-item.vue?vue&type=template&id=3ea230c7&scoped=true&lang=pug&"
import script from "./app-bar-notification-item.vue?vue&type=script&lang=ts&"
export * from "./app-bar-notification-item.vue?vue&type=script&lang=ts&"
import style0 from "./app-bar-notification-item.vue?vue&type=style&index=0&id=3ea230c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea230c7",
  null
  
)

export default component.exports